import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppStatic, ContentService, TypableService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';

import * as LottiePlayer from "@lottiefiles/lottie-player";



// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit, OnDestroy {

  slug = 'services'
  content: any
  fields: any

  hoveringServiceIndex: number
  typableIntersectionObserver: any
  metadataSlugs = [
    'services-page-service-description-placeholder-length',
    'learn-more-arrow-1'
  ]
  metadata: any = {}
  descriptionPlaceholder: string
  learnMoreArrowMedia: any

  destroy$: Subject<boolean> = new Subject<boolean>();

  initializedVideos: any[] = []

  isSafari: boolean


  constructor(
    private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    public typableService: TypableService
  ) { }

  ngOnInit(): void {
    this.getMetadata()
    this.getPage()

    this.isSafari = navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    setTimeout(() => { this.destroy$.unsubscribe() }, 1000);
  }

  // ngAfterViewInit() {
  //   const videos = document.querySelectorAll('.services-service-video video')
  //   videos.forEach(video => {
  //     video.requestVideoFrameCallback((now, metadata) => {
  //       this.checkVideoFrameLoop(video, metadata, meta)
  //     })
  //   })
  // }

  initIntersectionObservers() {
    if (!AppStatic.isBrowser) return
    const mobileWrappers = document.getElementsByClassName('typable-wrapper-mobile')
    if (!mobileWrappers) return console.log('!mobileWrappers')
    const mobileWrappersArray = Array.prototype.slice.call( mobileWrappers )

    for (const [i, el] of mobileWrappersArray.entries()) {      
      const mobileServiceElement = el.querySelector('.typable-container')
      // console.log('CHECK mobileServiceElements', mobileServiceElement)
      const block = this.fields['sections'][0].fields['items'][i]
      if (!block) console.log('ERR: initIntersectionObserver !block')
      this.typableIntersectionObserver = this.typableService.initIntersectionObserver(mobileServiceElement, { block: block, removeCursorAfterTyping: true })
    }
  }

  getMetadata() {
    this.contentService.getMetadata({'fields.slug[in]': this.metadataSlugs.join(',') }) // { slug: 'scroll-arrow-icon' })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (meta: any) => {
        try {
          if (!meta.items[0]) return console.log('ERR: !meta', meta)
          
          for (let item of meta.items) {
            let val
            switch (item.fields['type']) {
              case 'other':
              case 'string': val = item.fields['value']; break;
              case 'number': val = +item.fields['value']; break;
              case 'media': val = item.fields['media']; break;
              case 'items': val = item.fields['items']; break;
            }
            this.metadata[item.fields['slug']] = val // NOTE: ALL NUMBERS this time
          }
          const descriptionPlaceholderArray = Array(this.metadata['services-page-service-description-placeholder-length']).fill('x')
          this.descriptionPlaceholder = descriptionPlaceholderArray.join('')
          this.learnMoreArrowMedia = this.metadata['learn-more-arrow-1'][0]
          // console.log('CHECK: meta', meta, this.learnMoreArrowMedia, this.metadata) // this.descriptionPlaceholder, this.metadata)
        } catch {
          console.log('ERR: getMetadata', meta)
        }
      }
    })
  }

  getPage(){
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        this.fields = this.content.items[0].fields
        // console.log('fields', this.fields)
        // this.initLottie()
        setTimeout(() => {
          this.initIntersectionObservers()
        }, 500)
      }
    });
  }

  // initLottie() {
  //   const lottiePlayers = document.getElementsByClassName('lottie-player')
  //   Array(lottiePlayers).forEach((lottiePlayer, index) => {
  //     // console.log('lottiePlayer', lottiePlayer, index)
      
  //   })
  // }

  async handleHoverService(params={}) {
    const block = params['block']
    delete params['block']
    const text = documentToPlainTextString(block.fields['body']) + "  "

    const evt = params['event']
    const container = evt && evt.target && evt.target.closest('.typable-container')
    const typableTextElement = container.querySelector('.typable-text')
    const textParams = Object.assign({}, params, { text: text, typableTextElement: typableTextElement })
    // console.log('TODO: link', block)
    const wasTyped = await this.typableService.typeText(textParams)
    // console.log('wasTyped', wasTyped)
    if (!wasTyped) return // console.log('CHECK !wasTyped')

    const linkAddress = block.fields['linkAddress']
    const linkText = block.fields['linkText']
    if (linkText && linkAddress) {
      const typableTextElement = container.querySelector('.typable-link')
      const linkParams = Object.assign({}, params, { link: { text: linkText, address: linkAddress }, typableTextElement: typableTextElement, repeatable: true })
      this.typableService.typeText(linkParams)
    }
  } 

  handleBlurService(params={}) {
    const target = params['event'].target
    const repeatables = target.querySelectorAll('.typable-repeatable')
    this.typableService.resetRepeatables(repeatables)
  }

  documentToPlainTextString(doc) {
    return documentToPlainTextString(doc)
  }

  handleSelectService(block) {
    // console.log('TODO: handleSelectService', block)
    const link = this.lcpHelper.linkFromBlock(block)
    if (!link) return
    this.router.navigate([link.address])
  }

  handleMouseEnterService(evt: any, block) {
    const video = evt.target.querySelector('video')
    try { 

      if (this.initializedVideos.indexOf(video) < 0) {
        this.initializedVideos.push(video)
        const meta = block['fields']['items'][0]['fields']['metadata'] 
        video.requestVideoFrameCallback((now, metadata) => {
          this.checkVideoFrameLoop(video, metadata, meta)
        })
      }

      video.muted = true
      video.load()
      video.currentTime = 0
      video.play()
      // console.log('TODO: handleMouseEnterService', video, block)
    }
    catch { return }


    // const lottiePlayer = evt.target.querySelector('lottie-player')
    // // console.log('lottiePlayer', lottiePlayer, block['fields']['items'][0]['fields'])
    // if (!lottiePlayer) return
    // // lottiePlayer.setProgress(0)
    // lottiePlayer.seek(0)
    // // lottiePlayer.playSegments([1,0], true);
    // // lottiePlayer.setSpeed(1);
    // lottiePlayer.play()

  }

  // ASSUMPTION: 30FPS
  checkVideoFrameLoop(video, metadata, data) {
    // console.log('New video frame presented:', metadata.mediaTime);
    const loopStart = data['loopStart']

    // ends one frame before animation (30FPS)
    const loopEnd = data['loopEnd'] - 0.05 // 34 // 1/30 

    // if (metadata.mediaTime >= loopStart - 1/30) {
    //   console.log('LOOP START', metadata.mediaTime)
    //   video.pause()
    // }

    // console.log('LOOP', loopStart, loopEnd, metadata.mediaTime)

    if (metadata.mediaTime >= loopEnd) {
      // console.log('LOOPING', video) //  loopStart, metadata.mediaTime, loopEnd, data)
      // video.pause()
      video.currentTime = loopStart
      video.play()
    }
    video.requestVideoFrameCallback((nextNow, nextMetadata) => {
      this.checkVideoFrameLoop(video, nextMetadata, data)
      // ... process next frame ...
    });
  }
}
